class UpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderRef = this;
    this.nextRef =
      document.querySelector(".recommendation-panel-wrapper-next") || null;
    this.previousRef =
      document.querySelector(".recommendation-panel-wrapper-previous") || null;
    this.paginationRef = this.querySelector("[data-pagination]") || null;
    this.initSlider = this.initSlider.bind(this);
    this.autoPlay = false;
    this.spaceBetween = 30;
    this.loop = false;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderRef, {
      // Optional parameters
      loop: this.loop,
      spaceBetween: this.spaceBetween,
      slidesPerView: "auto",
      autoplay: this.autoPlay || false,
      grabCursor: true,
      mousewheel: true,
      direction: "vertical",

      keyboard: {
        enabled: true,
      },

      // If we need pagination
      pagination: {
        el: this.paginationRef,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.nextRef,
        prevEl: this.previousRef,
      },
    });
  }

  disconnectedCallback() {
    this.swiper.destroy();
  }
}
customElements.define("upsell-slider", UpsellSlider);

class UpsellSliderMobile extends HTMLElement {
  constructor() {
    super();
    this.sliderRef = this.querySelector("[data-slider]");
    this.nextRef = this.querySelector('[data-navigation="next"]') || null;
    this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
    this.paginationRef = this.querySelector("[data-pagination]") || null;
    this.initSlider = this.initSlider.bind(this);
    this.autoPlay = false;
    this.spaceBetween = 10;
    this.loop = false;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderRef, {
      // Optional parameters
      slidesPerView: 1.5,
      loop: this.loop,
      spaceBetween: this.spaceBetween,
      autoplay: this.autoPlay || false,
      grabCursor: true,

      keyboard: {
        enabled: true,
      },

      // If we need pagination
      pagination: {
        el: this.paginationRef,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.nextRef,
        prevEl: this.previousRef,
      },
    });
  }

  disconnectedCallback() {
    this.swiper.destroy();
  }
}
customElements.define("upsell-slider-mobile", UpsellSliderMobile);
